export default [
    {
        id: 1,
        abb_ca: 'Sr.',
        abb_en: 'Mr',
        abb_es: 'Sr.',
        name_ca: 'Senyor',
        name_en: 'Mister',
        name_es: 'Señor',
        gender: 'male'
    },
    {
        id: 2,
        abb_ca: 'Sra.',
        abb_en: 'Ms',
        abb_es: 'Sra.',
        name_ca: 'Senyora',
        name_en: 'Miss',
        name_es: 'Señora',
        gender: 'female'
    },
    {
        id: 3,
        abb_ca: 'Srta.',
        abb_en: 'Mss',
        abb_es: 'Srta.',
        name_ca: 'Senyoreta',
        name_en: 'Misses',
        name_es: 'Señorita',
        gender: 'female'
    },
    {
        id: 4,
        abb_ca: 'Don',
        abb_en: 'Don',
        abb_es: 'Don',
        name_ca: 'Don',
        name_en: 'Don',
        name_es: 'Don',
        gender: 'male'
    },
    {
        id: 5,
        abb_ca: 'Doña',
        abb_en: 'Doña',
        abb_es: 'Doña',
        name_ca: 'Doña',
        name_en: 'Doña',
        name_es: 'Doña',
        gender: 'female'
    },
    {
        id: 6,
        abb_ca: 'Dr.',
        abb_en: 'Dr',
        abb_es: 'Dr.',
        name_ca: 'Doctor',
        name_en: 'Doctor',
        name_es: 'Doctor',
        gender: 'male'
    },
    {
        id: 7,
        abb_ca: 'Dra.',
        abb_en: 'Dra',
        abb_es: 'Dra.',
        name_ca: 'Doctora',
        name_en: 'Doctora',
        name_es: 'Doctora',
        gender: 'female'
    },
    {
        id: 8,
        abb_ca: 'Excm. Sr.',
        abb_en: 'The Most Excellent Mr',
        abb_es: 'Excmo. Sr.',
        name_ca: 'Excel·lentíssim Senyor',
        name_en: 'The Most Excellent Mister',
        name_es: 'Excelentísimo Señor',
        gender: 'male'
    },
    {
        id: 9,
        abb_ca: 'Excm. Sra.',
        abb_en: 'Most Excellent Ms',
        abb_es: 'Excma. Sra.',
        name_ca: 'Excel·lentíssima Senyora',
        name_en: 'The Most Excellent Miss',
        name_es: 'Excelentísima Señora',
        gender: 'female'
    }
]



// WEBPACK FOOTER //
// ./src/options/honorific_titles.js